var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NotificationMessage',{attrs:{"avatar":_vm.message.avatar,"text":'We suggest sending ' + _vm.message.customerName + ' a message explaining why you declined.'}})}
var staticRenderFns = []

export { render, staticRenderFns }